export default "__VITE_ASSET__ZeAdCGwc__"